<template>
  <el-dialog
    :title="`新建${newTeam.parentId ? '子' : ''}团队`"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="400px"
  >
    <div class="form-row">
      <span class="dialog-title"> 团队名称： </span>
      <el-input v-model="newTeam['teamName']" class="value" placeholder="团队名称" size="mini" />
    </div>
    <div v-if="newTeam.depth === 2" class="form-row">
      <span class="dialog-title"> 团队类型： </span>
      <el-select v-model="newTeam['teamType']" class="value" placeholder="团队类型" filterable size="mini">
        <el-option v-for="item in teamTypes" :key="item" :label="item" :value="item"> </el-option>
      </el-select>
    </div>
    <div class="form-row">
      <span class="dialog-title"> 团队负责人： </span>
      <el-select v-model="newTeam['leader']" class="value" placeholder="团队负责人" filterable size="mini">
        <el-option v-for="item in chooseAccounts" :key="item" :label="item" :value="item"> </el-option>
      </el-select>
    </div>
    <div v-if="newTeam.parentId" class="form-row">
      <span class="dialog-title"> 团队成员： </span>
      <el-select
        v-model="newTeam['members']"
        class="value"
        placeholder="团队成员"
        multiple
        filterable
        size="mini"
        @remove-tag="removeMember"
      >
        <el-option v-for="item in chooseAccounts" :key="item" :label="item" :value="item"> </el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmDialog">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      teamTypes: ['业务团队', '技术团队', '行政团队', '数据团队'],
      dialogVisible: false,
      newTeam: { teamName: '', members: [] },
      accounts: [],
      chooseAccounts: [],
    }
  },
  watch: {
    newTeam: {
      handler(newValue, oldValue) {
        if (newValue.parentId && newValue.leader) {
          if (!newValue.members) this.$set(newValue, 'members', [])
          if (!newValue.members.includes(newValue.leader)) {
            newValue.members.push(newValue.leader)
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    await this.getAccounts()
  },
  methods: {
    async getAccounts() {
      const res = await app.service('misc').listAccounts()
      this.accounts = (res.data || []).filter(v => v && v.状态 !== '离职中' && v.状态 !== '已离职').map(v => v.account)
    },
    removeMember(member) {
      const { newTeam } = this
      if (newTeam.leader === member) this.$message.info('不能将负责人移除')
    },
    async confirmDialog() {
      if (this.loading) return this.$message.success('保存中，请勿重复提交')
      this.loading = true
      try {
        const res = await app.service('company').addTeam(this.newTeam)
        if (res.status === 'success') {
          this.$message.success('添加成功')
          this.$emit('addTeam')
          this.dialogVisible = false
        } else this.$message.error(res.msg)
      } catch (e) {
        this.$message.error(e.message)
      }
      this.loading = false
    },
    open(parentTeam = {}) {
      const newTeam = {}
      if (parentTeam._id) newTeam.parentId = parentTeam._id

      if (!parentTeam._id) newTeam.depth = 1
      else if (parentTeam.parentId) newTeam.depth = 3
      else newTeam.depth = 2

      if (newTeam.depth === 3) newTeam.teamType = parentTeam.teamType
      if (newTeam.depth === 3) this.chooseAccounts = parentTeam.members
      else this.chooseAccounts = this.accounts

      this.newTeam = newTeam
      this.dialogVisible = true
    },
  },
}
</script>
<style scoped>
.form-row {
  display: flex;
  margin-bottom: 5px;
}
.form-row .dialog-title {
  word-break: keep-all;
}
.form-row .value {
  flex-grow: 1;
}
</style>
